import { ActionTree } from 'vuex';
import { LoginState } from './state';
import RootState from '@/store/root_state';
import { MicroserviceEnum, mutation } from '@/helpers/westeros';
import {
  sendLoginCode,
  SendLoginCodeMutationResult,
  ValidateLoginCodeMutationResult,
  validateLoginCode,
  CreateAuthTokenMutationResult,
  createAuthToken,
} from '@/store/graphql/mutations/westerosMutations';
import Analytics from '@/helpers/analytics';

const actions: ActionTree<LoginState, RootState> = {
  async SEND_LOGIN_CODE(
    { commit, state, rootState },
    payload: { selectedChannel?: string } = {},
  ): Promise<void> {
    const { selectedChannel = state.selectedChannel } = payload;

    const variables = { userId: rootState.user.user?.id, notificationChannel: selectedChannel };

    const { data } = await mutation<SendLoginCodeMutationResult>(
      MicroserviceEnum.ADMISSIONS,
      sendLoginCode,
      variables,
    );

    const isCodeSent = data?.sendLoginCode.sent;

    if (isCodeSent) commit('SET_LOGIN_SELECTED_CHANNEL', selectedChannel);
    else throw new Error();
  },

  async VALIDATE_LOGIN_CODE({ commit, rootState }, payload): Promise<void> {
    const { code } = payload;

    const { id: userId, name = '', email = '' } = rootState.user.user || {};

    const variables = { userId, loginCode: code };

    let success = false;
    try {
      const { data } = await mutation<ValidateLoginCodeMutationResult>(
        MicroserviceEnum.ADMISSIONS,
        validateLoginCode,
        variables,
      );

      success = data?.validateLoginCode.success || false;

      if (success) {
        Analytics.identify({ id: email, email, name });
        commit('SET_AUTH_TOKEN', data?.validateLoginCode.authToken);
      }
    } finally {
      commit('SET_LOGIN_SUCCESS', success);
    }
  },

  async CREATE_AUTH_TOKEN({ commit, rootState }): Promise<void> {
    const { email = '' } = rootState.user.user || {};
    const variables = { email };

    let success = false;
    try {
      const { data } = await mutation<CreateAuthTokenMutationResult>(
        MicroserviceEnum.ADMISSIONS,
        createAuthToken,
        variables,
      );

      success = !!data?.createAuthToken.authToken || false;

      if (success) {
        commit('SET_AUTH_TOKEN', data?.createAuthToken.authToken);
      }
    } finally {
      commit('SET_LOGIN_SUCCESS', success);
    }
  },

  async CLEAR_LOGIN_DATA({ commit }): Promise<void> {
    const user = {
      name: null,
      email: null,
      phone: null,
      signupMethod: null,
    };

    commit('SET_AUTH_TOKEN', '');
    commit('SET_LOGIN_SUCCESS', false);
    commit('SET_USER', user);
  },
};

export default actions;
